import {useEffect} from 'react'

interface IListSearchExpiration {
  searchDueDateStart: string
  setSearchDueDateStart: (value: string) => void
  searchDueDateEnd: string
  setSearchDueDateEnd: (value: string) => void
  errorsDueDate: string[]
  setErrorsDueDate: (value: string[]) => void
}

const ListSearchExpiration = ({
  setSearchDueDateStart,
  searchDueDateStart,
  setSearchDueDateEnd,
  searchDueDateEnd,
  errorsDueDate,
  setErrorsDueDate,
}: IListSearchExpiration) => {
  useEffect(() => {
    if (searchDueDateStart.length === 10 && searchDueDateEnd.length === 10) {
      if (
        new Date(searchDueDateStart).setHours(0, 0, 0, 0) >
        new Date(searchDueDateEnd).setHours(0, 0, 0, 0)
      ) {
        const novosErros = [...errorsDueDate]
        novosErros[0] = 'Data inicial deve ser menor que data final'
        novosErros[1] = 'Data inicial deve maior que data final'
        setErrorsDueDate(novosErros)
        return
      }
    } else if (searchDueDateStart.length === 10 && searchDueDateEnd.length < 10) {
      const novosErros = [...errorsDueDate]
      novosErros[0] = ''
      novosErros[1] = 'Data final deve ser informada'
      setErrorsDueDate(novosErros)
      return
    } else if (searchDueDateEnd.length === 10 && searchDueDateStart.length < 10) {
      const novosErros = [...errorsDueDate]
      novosErros[0] = 'Data inicial deve ser informada'
      novosErros[1] = ''
      setErrorsDueDate(novosErros)
      return
    }
    const novosErros = [...errorsDueDate]
    novosErros[0] = ''
    novosErros[1] = ''
    setErrorsDueDate(novosErros)
  }, [searchDueDateStart, searchDueDateEnd])

  return (
    <>
      <div className='mb-5 row'>
        <div className='col-6'>
          <label className='form-label fs-6 fw-bold'>
            Pesquisar Por Data De Vencimento: Inicial
          </label>
          <input
            type='date'
            data-kt-user-table-filter='birthDate'
            className='form-control form-control-solid w-100'
            placeholder='Data inícial'
            value={searchDueDateStart}
            onChange={(e) => setSearchDueDateStart(e.target.value)}
            min='2015-12-31'
            maxLength={10}
          />
          {errorsDueDate && errorsDueDate.length > 0 && errorsDueDate[0] ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block fs-6'>{errorsDueDate[0]}</div>
            </div>
          ) : null}
        </div>
        <div className='col-6'>
          <label className='form-label fs-6 fw-bold'>Pesquisar Por Data De Vencimento: Final</label>
          <input
            type='date'
            data-kt-user-table-filter='dtEnd'
            className='form-control form-control-solid'
            placeholder='Data Final'
            value={searchDueDateEnd}
            onChange={(e) => setSearchDueDateEnd(e.target.value)}
            min='2015-12-31'
            maxLength={10}
          />
          {errorsDueDate && errorsDueDate.length > 0 && errorsDueDate[1] ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block fs-6'>{errorsDueDate[1]}</div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  )
}

export {ListSearchExpiration}
